import { connect } from '../../../react-redux';
import { isEditingQuizEntry } from '../../../selectors/quizzes';
export default (function (ComposedComponent) {
  var mapStateToProps = function mapStateToProps(state) {
    return {
      disableDraggingOverride: isEditingQuizEntry(state)
    };
  };
  return connect(mapStateToProps)(ComposedComponent);
});